import { ElementSize, ModalSize } from "@via/utils/constants.tsx";
import { classNames } from "@via/utils/helpers.tsx";
import { type JSX } from "react";

export const Avatar = ({
  name,
  notifications = false,
  size = ModalSize.Small,
}: {
  name: string;
  notifications: boolean;
  size?: string;
}): JSX.Element => {
  const initials: string =
    name
      ?.split(/[ _]/)
      .map(s => s.charAt(0))
      .join("") ?? "SW";

  return (
    <>
      <span
        className={classNames(
          size === ElementSize.Large ? "h-10 w-10" : "h-8 w-8",
          "inline-flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-600 to-indigo-500 opacity-90 shadow-sm"
        )}>
        <span
          title={name}
          className="text-sm font-medium leading-none text-white">
          {initials}
        </span>
      </span>
      {notifications && (
        <span className="absolute right-0 top-0 block h-2 w-2 rounded-full bg-red-400 ring-2 ring-white" />
      )}
    </>
  );
};
